import React, { FC } from 'react'
import s from './property.m.scss'
import clsx from 'clsx'

interface Props {
  keyName: string
}

export const Property: FC<Props> = ({ children, keyName }) => (
  <tr className={clsx(s.property, keyName.toLowerCase())}>
    <td className='title six wide top aligned' colSpan={children ? 1 : 2}>
      {keyName}
    </td>
    {!!children && <td className=''>{children}</td>}
  </tr>
)
